import { parseParams } from '@wix/music-shared/dist/src/utils/url';

export function getFullLocale(): string {
  const { dateNumberFormat } = parseParams();
  return typeof dateNumberFormat === 'string' &&
    dateNumberFormat.match(/^[a-z]+(-[a-z]+)?$/i)
    ? dateNumberFormat
    : undefined;
}
